import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroSection from '@/components/landing/hero-section'
import ServicesSection from '@/components/landing/services-section'
import ProcessSection from '@/components/landing/process-section'
import ContactSection from '@/components/landing/contact-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection />
            <ServicesSection />
            <ProcessSection />
            <ContactSection />
        </Layout>
    )
}

export default Home
